"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = require("../../Theme/Theme.variables");

var _styledSystem = require("styled-system");

var _Box = require("../../components/Box/Box");

var _Icons = _interopRequireDefault(require("../../components/Icons/Icons"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-family: ", ";\n  font-size: ", "px;\n  letter-spacing: ", ";\n  line-height: ", ";\n  display: inline-block;\n\n  color: ", ";\n\n  &:disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  appearance: none;\n\n  width: 100%;\n  padding: ", "px ", "px ", "px\n    0;\n  border-radius: 0px;\n  border: none;\n  border-bottom: 1px solid ", ";\n\n  background-color: ", ";\n  background-image: url(https://gentux.imgix.net/1554124311_TriangleDown.png);\n  background-size: 15px;\n  background-position: right center;\n  background-repeat: no-repeat;\n  box-shadow: none;\n\n  position: relative;\n  svg {\n    position: absolute;\n    z-index: 100;\n    top: 0;\n    right: 0;\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var StyledSelect = _styledComponents.default.select(_templateObject(), function (props) {
  return (0, _Theme.variables)(props).fontBody;
}, function (props) {
  return props.small ? (0, _Theme.variables)(props).fontSizeSm : (0, _Theme.variables)(props).fontSizeBase;
}, function (props) {
  return props.small ? (0, _Theme.variables)(props).letterSpacing.body[2] : (0, _Theme.variables)(props).letterSpacing.body[1];
}, function (props) {
  return (0, _Theme.variables)(props).fontBaseLineHeight;
}, function (props) {
  return props.value === '' ? (0, _Theme.variables)(props).grayDark : (0, _Theme.variables)(props)[props.textColor];
}, function (props) {
  return (0, _Theme.variables)(props).grayDark;
}, function (props) {
  return _Theme.space[2];
}, function (props) {
  return _Theme.space[4];
}, function (props) {
  return _Theme.space[2];
}, function (props) {
  return (0, _Theme.variables)(props)[props.borderColor];
}, function (props) {
  return (0, _Theme.variables)(props)[props.backgroundColor];
}, _styledSystem.space);

var Select = function Select(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  return _react.default.createElement(StyledSelect, _extends({
    id: props.id,
    name: props.name,
    value: props.value
  }, props), children);
};

exports.Select = Select;
Select.displayName = 'Select'; // Prop Types

Select.propTypes = {
  borderColor: _propTypes.default.string,
  textColor: _propTypes.default.string,
  backgroundColor: _propTypes.default.string
};
Select.defaultProps = {
  borderColor: 'black',
  textColor: 'black',
  backgroundColor: 'white'
};